(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["brand-presentation-trio"] && !Shopify.designMode) return;
  try {
    (() => {
  const videos = document.querySelectorAll('.lv-presentation-trio video');
  videos.forEach(video => { video.controls = false; video.muted = true; video.defaultMuted = true; });
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    videos.forEach(video => { video.autoplay = false; video.pause(); });
  }
})();
  } catch(e) { console.error(e); }
})();

})();
